'use client'

import { trackFaqPerguntaAberta } from '@/lib/analytics'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface FAQItem {
  pergunta: string
  resposta: string
}

interface FAQCategory {
  titulo: string
  perguntas: FAQItem[]
}

interface FAQTrackingWrapperProps {
  faqContent: FAQCategory[]
}

export function FAQTrackingWrapper({ faqContent }: FAQTrackingWrapperProps) {
  return (
    <div className="space-y-8">
      {faqContent.map((categoria, categoriaIndex) => (
        <div key={categoriaIndex} className="space-y-4">
          <h2 className="text-xl sm:text-2xl font-bold text-foreground">
            {categoria.titulo}
          </h2>
          <Accordion
            type="multiple"
            className="w-full bg-card rounded-lg border border-border divide-y divide-border"
          >
            {categoria.perguntas.map((item, index) => (
              <AccordionItem
                key={`${categoriaIndex}-${index}`}
                value={`item-${categoriaIndex}-${index}`}
                className="border-b-0"
              >
                <AccordionTrigger
                  className="text-base sm:text-lg"
                  onClick={() => trackFaqPerguntaAberta(item.pergunta)}
                >
                  {item.pergunta}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base">
                  {item.resposta}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ))}
    </div>
  )
}
